import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { select } from '@ngneat/elf';
import { aoInitialState, AoStateProps, aoStateStore } from './ao-state.store';

@Injectable({
  providedIn: 'root',
})
export class AoRepository extends BaseStoreRepository<AoStateProps> {
  constructor() {
    super(aoStateStore.pipe(select(state => state)), aoStateStore, aoInitialState);
  }
}
